module.exports = __webpack_public_path__ + "img/shop.0d0c290f.svg";